import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var VideoOff = createReactComponent("VideoOff", ["svg", defaultAttributes, [["path", {
  d: "M16 16v1a2 2 0 01-2 2H3a2 2 0 01-2-2V7a2 2 0 012-2h2m5.66 0H14a2 2 0 012 2v3.34l1 1L23 7v10",
  key: "oq19pp"
}], ["line", {
  x1: "1",
  y1: "1",
  x2: "23",
  y2: "23",
  key: "czowfk"
}]]]);
export default VideoOff;